import { makeAuthenticatedRequest, parseErrorResponse } from '../../../core/api/client';

export const enquiriesApi = {
  getAllEnquiries: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (typeof params.limit === 'number') queryParams.append('limit', String(params.limit));
    if (typeof params.offset === 'number') queryParams.append('offset', String(params.offset));
    if (params.month) queryParams.append('month', params.month);
    if (params.from_date) queryParams.append('from_date', params.from_date);
    if (params.to_date) queryParams.append('to_date', params.to_date);
    const suffix = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const response = await makeAuthenticatedRequest(`/api/v1/enquiries/${suffix}`);
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  },
  getEnquiry: async (enquiryId) => {
    const response = await makeAuthenticatedRequest(`/api/v1/enquiries/${enquiryId}`);
    if (!response.ok) throw new Error("Failed to fetch enquiry");
    return response.json();
  },
  getEnquirySummary: async (month, fromDate, toDate) => {
    const qp = new URLSearchParams();
    if (month) qp.append('month', month);
    if (fromDate) qp.append('from_date', fromDate);
    if (toDate) qp.append('to_date', toDate);
    const q = qp.toString() ? `?${qp.toString()}` : '';
    const response = await makeAuthenticatedRequest(`/api/v1/enquiries/summary-stats${q}`);
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    const data = await response.json();
    return data && typeof data === 'object' ? data : {};
  },

  createEnquiry: async (payload) => {
    const response = await makeAuthenticatedRequest('/api/v1/enquiries/', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    return await response.json();
  },

  updateEnquiry: async (enquiryId, payload) => {
    const response = await makeAuthenticatedRequest(`/api/v1/enquiries/${enquiryId}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    return await response.json();
  },
  closeEnquiry: async (enquiryId, reason) => {
    const response = await makeAuthenticatedRequest(`/api/v1/enquiries/${enquiryId}/close`, {
      method: 'POST',
      body: JSON.stringify({ reason }),
    });
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    return await response.json();
  },
  reopenEnquiry: async (enquiryId) => {
    const response = await makeAuthenticatedRequest(`/api/v1/enquiries/${enquiryId}/reopen`, {
      method: 'POST',
      body: JSON.stringify({}),
    });
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    return await response.json();
  },

  getGradeMasters: async (limit = 1000) => {
    const response = await makeAuthenticatedRequest(`/api/v1/enquiries/masters/grades?limit=${limit}`);
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  },

  getToleranceMasters: async () => {
    const response = await makeAuthenticatedRequest('/api/v1/enquiries/masters/tolerances');
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  },

  importItems: async (formData) => {
    const response = await makeAuthenticatedRequest('/api/v1/enquiries/import-items', {
      method: 'POST',
      body: formData,
    });
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    return await response.json();
  },
  getDailyCounts: async (days = 30) => {
    const response = await makeAuthenticatedRequest(`/api/v1/enquiries/daily-counts?days=${days}`);
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    return await response.json();
  },
};
